<template>
  <div class="container">
    <div class="lg:px-16 px-5 mt-16 ">
      <form @submit.prevent="handleSubmit" class="p-9 rounded-lg bg-white dark:bg-gray-800">
        <h4>Create a New PostList</h4>
        <input type="text" required placeholder="Judul artikel / pelajaran" v-model="title" class="dash italic" />
        <textarea required placeholder="Deskripsi singkat" v-model="body" class="dash italic"></textarea>
        <label>Tags (hit enter to add a tag):</label>
        <input @keydown.enter.prevent="handleKeydown" required placeholder="Isi tags atau topik--tekan enter sebelum Klik Create" v-model="tag" type="text" class="dash" />
        <div v-for="tag in tags" :key="tag">#{{ tag }}</div>
        <div class="error"></div>
        <button class="bg-gray-200 p-1 pl-2 pr-2 rounded-lg hover:bg-white">Create</button>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "vue"
import useCollection from "@/composables/useCollection"
import getUser from "@/composables/getUser"
import { timestamp } from "@/firebase/config"
import { useRouter } from "vue-router"

export default {
  setup() {
    const { error, addDoc } = useCollection("posts")
    const { user } = getUser()
    const router = useRouter()

    const title = ref("")
    const body = ref("")
    const tags = ref([])
    const tag = ref("")
    // const file = ref(null)
    // const fileError = ref(null)
    const isPending = ref(false)

    const handleKeydown = () => {
      if (!tags.value.includes(tag.value)) {
        tag.value = tag.value.replace(/\s/g, "") // remove all whitespace
        tags.value.push(tag.value)
      }

      tag.value = ""
    }

    const handleSubmit = async () => {
      if (title.value) {
        isPending.value = true
        // await uploadImage(file.value)
        const res = await addDoc({
          title: title.value,
          body: body.value,
          userId: user.value.uid,
          userName: user.value.displayName,
          tags: tags.value,
          // coverUrl: url.value,
          // filePath: filePath.value, // so we can delete it later
          chapters: [],
          createdAt: timestamp(),
        })

        isPending.value = false
        if (!error.value) {
          router.push({ name: "PostDetails", params: { id: res.id } })
        }
      }
    }

    return { title, body, handleKeydown, handleSubmit, tags, tag, isPending }
  },
}
</script>

<style></style>
